// extracted by mini-css-extract-plugin
export var changeIcon = "_61-4";
export var container = "_61-0";
export var divider = "_61-7";
export var externalLinkIcon = "_61-1";
export var green = "_61-5";
export var helpCircleIcon = "_61-3";
export var iconButton = "_61-2";
export var red = "_61-6";